import type { SVGProps } from 'react';
const SvgSignsPostSharpSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path d="M224 0h64v32h160l64 64-64 64H32V32h192zm0 224v-32h64v32h192v128H64L0 288l64-64zm64 160v128h-64V384z" />
  </svg>
);
export default SvgSignsPostSharpSolid;
